module.exports = __webpack_public_path__ + "img/13-min.9598f886.jpg";